<style lang="scss">
img {
	height: 16px;
	vertical-align: middle;
}
</style>
<template>
	<img :src="url" class="flag" @error="imageError" />
</template>

<script>
export default {
	name: "Flag",
	props: {
		code: {
			required: true,
			type: String,
			default: "world"
		}
	},
	computed: {
		url() {
			return `/flags/${this.code.toLowerCase()}.png`;
		}
	},
	methods: {
		imageError(event) {
			event.target.src = this.code.toLowerCase().includes("gb-") ? "/flags/gb.png" : "/flags/world.png";
		}
	}
};
</script>
